import {GitHubAvatar} from '@github-ui/github-avatar'
import {readAssigneeFromFragment} from '@github-ui/item-picker-assignee-relay'
import {userHovercardPath} from '@github-ui/paths'
import {Link} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {ParticipantFragment$key} from './__generated__/ParticipantFragment.graphql'
import styles from './Participant.module.css'

type ParticipantProps = {
  participant: ParticipantFragment$key
}

export function Participant({participant}: ParticipantProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment ParticipantFragment on User {
        # eslint-disable-next-line relay/must-colocate-fragment-spreads
        ...AssigneePickerSharedAssignee
      }
    `,
    participant,
  )
  // Using AssigneeFragment here since participants are converted to assignees in the assignee picker's update mutation
  const {login, avatarUrl} = readAssigneeFromFragment(data)
  return (
    <Link href={`/${login}`}>
      <GitHubAvatar
        src={avatarUrl}
        size={20}
        alt={`@${login}`}
        data-hovercard-url={userHovercardPath({owner: login})}
        className={styles.GitHubAvatar}
      />
    </Link>
  )
}

try{ Participant.displayName ||= 'Participant' } catch {}